module.exports = __webpack_public_path__ + "factors-video-background.d30d7825dbb2db4ca14aa7e6d0314d98.png";